import { garageListQuerySchema, type GarageInput } from '@chukua/common';
import { useDirectoryList } from '../../../hooks/use-directory-list';
import { useDirectoryMutations } from '../../../hooks/use-directory-mutations';
import { createGarage, deactivateGarage, listGarages, reactivateGarage, updateGarage, type GarageView } from '../garages.api';

/** The garage directory (`useDirectoryList`) plus create, edit, deactivate and reactivate. `afterChange` refreshes what a change can alter elsewhere: the catalogue a save may have added to. */
export function useGarages(afterChange: () => Promise<unknown>) {
  const { state, list, isRefreshing, reload } = useDirectoryList(garageListQuerySchema, listGarages);
  const mutations = useDirectoryMutations<GarageInput, GarageView>(
    { create: createGarage, update: updateGarage, deactivate: deactivateGarage, reactivate: reactivateGarage },
    async () => {
      await reload();
      await afterChange();
    },
  );

  return { state, list, isRefreshing, ...mutations };
}
